import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState, RefObject } from 'react';

// Hook to detect when a sticky element is actually sticking
const useIsSticking = () => {
  const $ = _c(4);
  const [is_sticking, setIsSticking] = useState(false);
  const stickyRef = useRef(null);
  const observerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (!stickyRef.current) {
        return;
      }
      const observerOptions = {
        threshold: [0, 1],
        rootMargin: "-1px 0px 0px 0px"
      };
      observerRef.current = new IntersectionObserver(t2 => {
        const [entry] = t2;
        setIsSticking(!entry.isIntersecting);
      }, observerOptions);
      const sentinel = document.createElement("div");
      sentinel.style.height = "1px";
      sentinel.style.width = "100%";
      sentinel.style.position = "absolute";
      sentinel.style.top = "0";
      sentinel.style.left = "0";
      if (stickyRef.current.parentNode) {
        (stickyRef.current.parentNode as HTMLElement).style.position = "relative";
        stickyRef.current.parentNode.insertBefore(sentinel, stickyRef.current);
      }
      observerRef.current.observe(sentinel);
      return () => {
        if (observerRef.current) {
          observerRef.current.disconnect();
        }
        if (sentinel.parentNode) {
          sentinel.parentNode.removeChild(sentinel);
        }
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== is_sticking) {
    t2 = [stickyRef, is_sticking];
    $[2] = is_sticking;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default useIsSticking;